// src/icons/KotlinTwoTone.tsx
import { useTheme } from "@emotion/react";
import { useId } from "react";
import { jsx, jsxs } from "@emotion/react/jsx-runtime";
function KotlinTwoTone() {
  const id = useId();
  const theme = useTheme();
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      width: "100%",
      viewBox: "0 0 25 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ jsx("g", { clipPath: `url(#clip0_286_537-${id})`, children: /* @__PURE__ */ jsx(
          "path",
          {
            d: "M24.333 24H0.333008V0H24.333L12.333 12L24.333 24Z",
            fill: "currentColor"
          }
        ) }),
        /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsx("clipPath", { id: `clip0_286_537-${id}`, children: /* @__PURE__ */ jsx(
          "rect",
          {
            width: "24",
            height: "24",
            fill: theme.bg,
            transform: "translate(0.333008)"
          }
        ) }) })
      ]
    }
  );
}

export {
  KotlinTwoTone
};
